export default {
    title: state => {
        return state.title;
    },
    indications: state => {
        return state.indications;
    },
    indication: state => {
        return state.indication;
    },
    indicationsToEdit: state => {
        return state.indicationsToEdit;
    },
    total : state => {
      return state.total
    },
}
